/**
 * this includes item type ids which can consider as a OCR payment
 */
export const OCR_ITEM_TYPE_IDS = [5, 27, 57, 11, 67];
